module.exports = __webpack_public_path__ + "static/media/pocket-open.a7096e6a.png";